export default {"src":"/_next/static/media/phone.4dde648c.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};